/* eslint-disable no-nested-ternary */
import { NavLink as RouterLink, matchPath, useLocation, useParams } from 'react-router-dom';

const { ListItemButton, useTheme, alpha, ListItemIcon, ListItemText, Collapse, List, styled } = require("@mui/material");
const { useState, useEffect } = require("react");

const { default: LucideIcon } = require("./LucideIcon");
const { default: Iconify } = require("./Iconify");

export function NavItem({ item, onCloseSidebar, isDesktop }) {
    const theme = useTheme();
    const { pathname } = useLocation();
    const { eventID } = useParams();

    const isActive = item.path && eventID ? pathname.startsWith(`/${eventID}${item.path}`) : item.path ? pathname.startsWith(item.path) : null;
    const hasChildren = Boolean(item.children);

    const [open, setOpen] = useState(isActive);

    useEffect(() => {
        if (isActive) setOpen(true);
    }, [isActive]);


    const baseStyle = {
        borderRadius: '7px',
        my: 0.5,
        height: 48,
        '&:hover': {
            backgroundColor: '#f2f2f2',
            color: 'text.primary',
        },
        ...(isActive && {
            bgcolor: alpha('#5E17EB', 0.08),
            color: '#5E17EB',
            fontWeight: 600,
        }),
    };

    /** 🔹 ITEM AVEC SOUS-MENU */
    if (hasChildren) {
        return (
            <>
                <ListItemButton sx={baseStyle} onClick={() => setOpen(!open)}>
                    <ListItemIcon sx={{ minWidth: 32, color: 'inherit', }}>
                        <LucideIcon name={item.icon} size={22} />
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                    <Iconify
                        icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
                        width={16}
                    />
                </ListItemButton>

                <Collapse in={open}>
                    <List disablePadding>
                        {item.children.map((child) => {
                            const childPath = eventID
                                ? `/${eventID}${child.path}`
                                : child.path;

                            const isChildActive = pathname === childPath;

                            return (
                                <ListItemButton
                                    key={child.path}
                                    component={RouterLink}
                                    to={childPath}
                                    onClick={() => {
                                        if (!isDesktop) {
                                            setTimeout(onCloseSidebar, 100);
                                        }
                                    }}
                                    sx={{
                                        pl: 6,
                                        height: 42,
                                        borderRadius: '7px',
                                        mx: 1,
                                        color: 'text.secondary',
                                        transition: 'all 0.2s ease',

                                        '&:hover': {
                                            backgroundColor: '#f2f2f2',
                                            color: 'text.primary',
                                        },

                                        ...(isChildActive && {
                                            bgcolor: alpha('#5E17EB', 0.08),
                                            color: '#5E17EB',
                                            fontWeight: 600,
                                        }),
                                    }}
                                >
                                    <ListItemText primary={child.title} />
                                </ListItemButton>
                            );
                        })}
                    </List>
                </Collapse>

            </>
        );
    }

    /** 🔹 ITEM SIMPLE */
    return (
        <ListItemButton
            component={RouterLink}
            to={eventID ? `/${eventID}${item.path}` : item.path}
            onClick={() => {
                if (!isDesktop) {
                    setTimeout(onCloseSidebar, 100);
                }
            }}
            sx={{
                ...baseStyle,
                ...(item.highlight && {
                    color: '#5E17EB',
                }),
            }}
        >
            <ListItemIcon sx={{ minWidth: 32, color: 'inherit', }}>
                <LucideIcon name={item.icon} size={22} />
            </ListItemIcon>
            <ListItemText primary={item.title} />
        </ListItemButton>
    );


}
